import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { UserSelector } from 'src/Entities/User/User.Selector';
import { CourseListRow } from 'src/components/CourseList';
import Wrapper from 'src/components/Wrapper';
import { getCoursesFromCategoryAndName, getCoursesFromName } from 'src/helpers/api';
import { ICourse } from 'src/types/Courses';
import SearchComponent from '../SeachPage/Seach.component';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';
import { Action, Dispatch } from 'redux';
import { webRemoveUserFavoriteAction, webSetUserFavoriteAction } from 'src/Entities/User/User.Actions';

type Props = RouteComponentProps<{ categoryId: string, id: string }> & {
  upcomingIds: number[];
  favoriteIds: number[];
  addToFavorite: (id: number) => void;
  removeFromFavorite: (id: number) => void;
};

const Titles = ({
  match,
  upcomingIds,
  favoriteIds,
  addToFavorite,
  removeFromFavorite,
}: Props) => {
  const [courses, setCourses] = React.useState<ICourse[]>([]);
  const [categoryId, courseId] = React.useMemo(
    () => {
      return [
        match.params.categoryId ? parseInt(match.params.categoryId, 10) : null,
        match.params.id ? parseInt(match.params.id, 10) : null,
      ];
    },
    [match.params]
  );

  const handleToggleFavorite = (id: number) => {
    if (favoriteIds.includes(id)) {
      removeFromFavorite(id);
    } else {
      addToFavorite(id);
    }
  };

  const title = React.useMemo(
    () => {
      const first = courses[0];

      if (categoryId) {
        return first ? first.categoryName : '';
      }

      return first ? first.name : '';
    },
    [courses, categoryId],
  );

  React.useEffect(() => {
    let promise: Promise<ICourse[]> | null = null;

    if (categoryId && courseId) {
      promise = getCoursesFromCategoryAndName(categoryId, courseId);
    } else if (courseId) {
      promise = getCoursesFromName(courseId);
    }

    if (promise) {
      promise.then(setCourses);
    }
  }, [categoryId, courseId]);

  return (
    <div className="has-background-gray-body inner-container">
      <div className="has-background-white">
        <Wrapper>
          <Breadcrumb className="pt3 pb3">
            <BreadcrumbItem>
              <Link to="/Home">FORSIDE</Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              {title}
            </BreadcrumbItem>
          </Breadcrumb>
        </Wrapper>
      </div>
      <Wrapper className="pt-10">
        <div className="has-background-white pr-14 mt-12">
          <SearchComponent
            className="-mt-6"
            style={{ transform: 'translateY(-1.5rem)' }}
          />
          <div className="pt-10 pb-5 pl-5 -mt-6 has-text-black">
            <h3 className="text-lg font-extrabold m-0 mb-5 uppercase ml-5">
              {title}
            </h3>

            <div className="space-y-5">
              {courses.map((course) => (
                <CourseListRow
                  key={course.id}
                  id={course.id}
                  themeId={course.themeId}
                  title={course.name}
                  categoryId={course.categoryId}
                  categoryName={course.categoryName}
                  location={course.locationName}
                  publicationDate={course.publicationDate}
                  startDate={course.startDate}
                  startTime={course.startTime}
                  endDate={course.endDate}
                  endTime={course.endTime}
                  isFavorite={favoriteIds.includes(course.id)}
                  isSignedUp={upcomingIds.includes(course.id)}
                  onToggleFavorite={handleToggleFavorite}
                />
              ))}
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};


const mapStateToProps = () => ({
  upcomingIds: UserSelector.getUserComingCourses()
    .map((course) => course.detailKursusId),
  favoriteIds: UserSelector.getUserFavoriteActivities()
    ?.map((course) => course.detailKursusId),
});

const mapDispatchToProps = (dispatch: Dispatch<Action<any>>) => ({
  addToFavorite: (id: number) =>
    dispatch(webSetUserFavoriteAction(id)),
  removeFromFavorite: (id: number) =>
    dispatch(webRemoveUserFavoriteAction(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Titles);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Titles/index.tsx